import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class PagePartners extends Component {
  		
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--' + block.bg_color}>
			    
			    	<div className="c-page__block__inner">
			    			    		
			    		<div className="c-partners">
			    		
			    			<div className="c-partners__inner">
				    			
						    	{block.partners.map((partner,i) =>
									{	
										return (
											<div className="c-partners__item">
												<div className="c-partners__item__inner">
													
													{partner.name && partner.logo_code &&
														<h3 className="c-partners__item__logo" dangerouslySetInnerHTML={{__html:partner.logo_code}}></h3>
													}
													
													{partner.text &&
														<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:partner.text}}></div>
													}
													
													{partner.button_text && partner.button_url &&
											    		<div className="c-buttons">
											    			{partner.button_url.indexOf('https') === -1 &&
												    			<Link to={{ pathname: partner.button_url }} className="c-button" dangerouslySetInnerHTML={{__html:partner.button_text}}></Link>
											    			}
											    			{partner.button_url.indexOf('https') !== -1 &&
												    			<a href={partner.button_url} className="c-button" dangerouslySetInnerHTML={{__html:partner.button_text}} target="_blank"></a>
											    			}
											    		</div>
										    		}
													
												</div>
											</div>
										)
									}
								)}
								
							</div>
																										
						</div>	
						
					</div>	
												    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
